<template>
  <div id="SaleAdmin">
    <TopNav />
    <LeftNav />
    <mu-container
      fluid
      class="main_content"
      :style="{marginLeft: !$store.state.menuExpand? '288px':'112px'}"
    >
      <mu-row>
        <mu-col :span="12">
          <mu-flex direction="column">
            <Breadcrumbs
              :navIcon="'build'"
              :title="{name:this.$t('saleAdmin.title')}"
            ></Breadcrumbs>
            <mu-paper class="custom-paper" style="margin-top:24px;">
              <mu-flex direction="column">
                <mu-flex
                  class="button_group_row"
                  align-items="center"
                  justify-content="between"
                  style="width: 100%;"
                >
                  <mu-flex align-items="between" class="more_query">
                    <el-form ref="selectSearchProp" :model="searchParam" :inline="true">
                      <mu-flex wrap="wrap">
                        <el-form-item :label="$t('saleAdmin.userName')">
                          <el-input v-on:keyup.enter.native="quickSearch" v-model="searchParam.userName" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('saleAdmin.companyName')">
                          <el-input v-on:keyup.enter.native="quickSearch" v-model="searchParam.companyName" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('saleAdmin.telephone')">
                          <el-input v-on:keyup.enter.native="quickSearch" v-model="searchParam.telephone" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('saleAdmin.orderNumber')">
                          <el-input v-on:keyup.enter.native="quickSearch" v-model="searchParam.serialNumber" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item
                          :label="$t('saleAdmin.status')"
                          style="margin-left: 24px"
                        >
                          <el-select
                          v-on:keyup.enter.native="quickSearch"
                            size="mini"
                            v-model="searchParam.status"
                            :placeholder="$t('common.choice')"
                          >
                            <el-option :label="$t('saleAdmin.status_submission')" value="0"></el-option>
                            <el-option :label="$t('saleAdmin.status_modify')" value="1"></el-option>
                            <el-option :label="$t('saleAdmin.status_complete')" value="2"></el-option>
                            <el-option :label="$t('saleAdmin.status_reject')" value="-1"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="快递单号">
                          <el-input v-on:keyup.enter.native="quickSearch" v-model="searchParam.sendNum" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item style="margin-left: 16px">
                          <mu-button color="primary" small @click="quickSearch">
                            <span>{{$t('button.search')}}</span>
                          </mu-button>
                          <mu-button flat small @click="clean">
                            <span>{{$t('button.clean')}}</span>
                          </mu-button>
                        </el-form-item>
                      </mu-flex>
                    </el-form>
                  </mu-flex>
                </mu-flex>
                <el-table
                  :empty-text="$t('common.emptyText')"
                  v-loading="tableLoading"
                  :data="tableData"
                  class="custom_el_table"
                  style="width: 100%;margin-top:24px;"
                >
                  <el-table-column
                    width="120"
                    :label="$t('saleAdmin.orderNumber')"
                    prop="serialNumber"
                  >
                    <template slot-scope="scope">
                      {{scope.row.serialNumber == null ? $t('saleAdmin.noSingleNumber') : scope.row.serialNumber}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    prop="userName"
                    :label="$t('saleAdmin.userName')"
                  ></el-table-column>
                  <el-table-column width="120" prop="companyName" :label="$t('saleAdmin.companyName')"></el-table-column>
                  <el-table-column prop="telephone" :label="$t('saleAdmin.telephone')"></el-table-column>
                  <el-table-column
                    width="100"
                    :label="$t('saleAdmin.deviceNum')"
                    prop="deviceNum"
                  ></el-table-column>
<!--                  <el-table-column prop="address" :label="$t('saleAdmin.address')"></el-table-column>-->
                  <el-table-column prop="status" :label="$t('saleAdmin.status')">
                    <template slot-scope="scope">
                      <mu-badge :content="$t('saleAdmin.status_submission')" color="grey500" v-if="scope.row.status == 0"></mu-badge>
                      <mu-badge :content="$t('saleAdmin.status_modify')" color="info" v-if="scope.row.status == 1"></mu-badge>
                      <mu-badge :content="$t('saleAdmin.status_complete')" color="success" v-if="scope.row.status == 2"></mu-badge>
                      <mu-badge content="维修测试" color="primary" v-if="scope.row.status == 4"></mu-badge>
                      <mu-badge content="报价中" color="primary" v-if="scope.row.status == 3"></mu-badge>
                      <mu-badge :content="$t('saleAdmin.status_reject')" color="secondary" v-if="scope.row.status == -1"></mu-badge>
                    </template>
                  </el-table-column>
                  <el-table-column prop="createTime" :label="$t('saleAdmin.createTime')">
                    <template slot-scope="scope">{{ scope.row.createTime | datetime}}</template>
                  </el-table-column>
                  <el-table-column prop="endTime" :label="$t('saleAdmin.endTime')">
                    <template slot-scope="scope">{{ scope.row.endTime | datetime}}</template>
                  </el-table-column>
                  <el-table-column align="center" prop="endTime" :label="$t('saleAdmin.endTimeFlag')">
                    <template slot-scope="scope">
                      <mu-badge :content="$t('common.true')" color="red" v-if="scope.row.endTime != null && scope.row.endTime < timestamp"></mu-badge>
                      <mu-badge :content="$t('common.false')" color="success" v-if="scope.row.endTime != null && scope.row.endTime > timestamp"></mu-badge>
                    </template>
                  </el-table-column>
                  <el-table-column prop="id" :label="$t('saleAdmin.opreation')" width="150" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" size="mini" @click="hanleOrder(scope.row.id)" v-if="scope.row.status != 2 && scope.row.serialNumber != null">
                        {{$t('saleAdmin.handle')}}
                      </el-button>
                      <el-button type="text" size="mini" @click="hanleOrder(scope.row.id)" v-if="scope.row.status == 2||scope.row.status == -1">
                        详情
                      </el-button>
                      <el-button type="text" size="mini" @click="confirmReceipt(scope.row)" v-if="scope.row.serialNumber == null">
                        {{$t('saleAdmin.confirmReceipt')}}
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <Pagination
                  :current="current"
                  :changePage="changePage"
                  style="width: 100%;margin-top:28px;"
                />
              </mu-flex>
            </mu-paper>
          </mu-flex>
        </mu-col>
      </mu-row>
    </mu-container>
    <!-- 设置结束时间日期 -->
    <el-dialog :close-on-click-modal="false"
               title="确认收货"
               :visible.sync="endTimeFlag">
      <mu-flex direction="column">
        <mu-row  style="width:100%;margin-bottom:16px;">
          <mu-col :span="3">
            <p class="item_cls">{{$t('saleAdmin.userName')}}：<span>{{order.userName}}</span></p>
          </mu-col>
          <mu-col :span="3">
            <p class="item_cls">{{$t('saleAdmin.companyName')}}：<span>{{order.companyName}}</span></p>
          </mu-col>
          <mu-col :span="3">
            <p class="item_cls">联系电话：<span>{{order.telephone}}</span></p>
          </mu-col>
        </mu-row>
        <mu-row  style="width:100%;margin-bottom:16px;">
          <mu-col :span="4">
            <p class="item_cls">快递单号：<span>{{order.sendNum}}</span></p>
          </mu-col>
          <mu-col :span="4">
            <p class="item_cls">快递公司：<span>{{order.sendExpressName}}</span></p>
          </mu-col>
        </mu-row>
        <mu-row  style="width:100%;margin-bottom:16px;">
          <mu-col :span="4">
            <p class="item_cls">设备数量：<span>{{order.deviceNum}}</span></p>
          </mu-col>
        </mu-row>
        <mu-row  style="width:100%;margin-bottom:16px;">
          <mu-col>
            <p class="item_cls">配件信息：<span>{{order.deviceAccessories}}</span></p>
          </mu-col>
        </mu-row>
      </mu-flex>
      <div style="margin: auto">
        <span class="item_cls">设置完成时间：</span>
        <el-date-picker
          v-model="endTime"
          type="datetime"
          placeholder="选择日期时间"
          align="right"
          value-format="timestamp"
          :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="endTimeFlag = false">{{$t('button.close')}}</el-button>
        <el-button type="primary"
                   @click="setEndTime">{{$t('button.confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import TopNav from "@/components/TopNav";
import LeftNav from "@/components/LeftNav";
import Breadcrumbs from "@/components/Breadcrumbs";
import Pagination from "@/components/Pagination";
import * as API from "@/api/saleAdmin";
export default {
  name: "SaleAdmin",
  inject:['reload'],
  data() {
    return {
      tableLoading: false,
      searchVal: "",
      tree: [],
      selectSearchProp: "",
      addRoleDialog: false,
      tableData: [],
      formLabelWidth: "125px",
      current: {
        pageSize: 10,
        page: 1,
        totalSize: 0
      },
      searchParam: {},
      endTimeFlag:false,
      endTime:null,
      order: {},
      timestamp:null,
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '明天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周后',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
    };
  },
  components: { TopNav, LeftNav, Breadcrumbs, Pagination },
  mounted() {
    this.getOrderList(this.searchParam);
  },
  watch: {
    '$store.state.lang':function() {
       this.reload();
    }
  },
  methods: {
    //获取分页一览
    getOrderList(searchParam) {
      var that = this;
      this.tableLoading = true;
      API.getPageList({
        currentPage: that.current.page,
        pageSize: that.current.pageSize,
        start: 0,
        data: searchParam
      }).then(res => {
        console.log(res);
        if (res.code == 200) {
          that.tableData = res.data.list;
          that.current.totalSize = res.data.total;
          that.current.page = res.data.currentPage;
          that.tableLoading = false;
          this.timestamp = Date.parse(new Date())
        }
      }).catch(() => {
              this.$toast.error(this.$t("tips.tip_msg_warning"));
      });
    },
    //关键字查询
    quickSearch() {
      this.getOrderList(this.searchParam);
    },
    clean() {
      this.searchParam = {};
      this.getOrderList(this.searchParam);
    },
    changePage() {
      this.getOrderList(this.searchParam);
    },
    hanleOrder(id) {
      console.log(id);
      this.$router.push('/saleAdmin/saleDesc/' + id);
    },
    confirmReceipt(scope){
      console.log(scope);
      this.endTimeFlag = true;
      this.order = scope;
      this.endTime = null;
    },
    setEndTime(){
      if(this.endTime == null){
        this.$toast.warning("请先选择时间！");
        return;
      }
      API.setSerialNumber({
        id:this.order.id,
        endTime:this.endTime
      }).then(res =>{
        if(res.code == 200){
          this.$toast.success(res.message);
          this.getOrderList();
          this.order = {};
          this.endTimeFlag = false;
        }
      })
    }
  }
};
</script>
<style scoped>
.left_tree {
  height: calc(100vh - 64px);
  background-color: rgba(255, 255, 255, 0.5);
  padding: 16px 8px;
  overflow: auto;
}
.right_block {
  padding: 20px 24px;
  height: calc(100vh - 64px);
  overflow: auto;
}



// WEBPACK FOOTER //
// src/views/saleService/SaleAdmin.vue